var map = {
	"./card1_1.png": 39,
	"./card1_2.png": 40,
	"./card1_3.png": 41,
	"./card1_4.png": 42,
	"./card1_5.png": 43,
	"./card2_1.png": 44,
	"./card2_10.png": 45,
	"./card2_2.png": 46,
	"./card2_3.png": 47,
	"./card2_4.png": 48,
	"./card2_5.png": 49,
	"./card2_6.png": 50,
	"./card2_7.png": 51,
	"./card2_8.png": 52,
	"./card2_9.png": 53,
	"./card3_1.png": 54,
	"./card3_10.png": 55,
	"./card3_2.png": 56,
	"./card3_3.png": 57,
	"./card3_4.png": 58,
	"./card3_5.png": 59,
	"./card3_6.png": 60,
	"./card3_7.png": 61,
	"./card3_8.png": 62,
	"./card3_9.png": 63,
	"./card4_1.png": 64,
	"./card4_10.png": 65,
	"./card4_2.png": 66,
	"./card4_3.png": 67,
	"./card4_4.png": 68,
	"./card4_5.png": 69,
	"./card4_6.png": 70,
	"./card4_7.png": 71,
	"./card4_8.png": 72,
	"./card4_9.png": 73,
	"./card5_1.png": 74,
	"./card5_10.png": 75,
	"./card5_13.png": 76,
	"./card5_2.png": 77,
	"./card5_3.png": 78,
	"./card5_4.png": 79,
	"./card5_5.png": 80,
	"./card5_6.png": 81,
	"./card5_7.png": 82,
	"./card5_8.png": 83,
	"./card5_9.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;